<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" :showTotal="true" :getTotal="getTotal"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../../hireTable";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
    };
  },
  methods: {},
  mounted() { },
};
</script>
